<template>
  <el-dialog
    :visible.sync="visible"
    width="500px"
    center
    custom-class="mic-permission-dialog"
    :append-to-body="true"
    :show-close="true"
    @close="$emit('close')">
    <div class="modal-content">
      <!-- BLOCKED STATE -->
      <template v-if="permanentlyDenied">
        <h2 class="modal-title">{{ type === 'mic' ? 'Microphone' : 'Camera' }} access is blocked</h2>
        <p class="modal-subtitle">Your browser has blocked {{ type === 'mic' ? 'microphone' : 'camera' }} access. Follow these steps to fix it:</p>
        <div class="steps">
          <div class="step">
            <span class="step-num">1</span>
            <span>Click the <strong>🔒 lock icon</strong> in your browser address bar</span>
          </div>
          <div class="step">
            <span class="step-num">2</span>
            <span>Find <strong>{{ type === 'mic' ? 'Microphone' : 'Camera' }}</strong> → Set to <strong>Allow</strong></span>
          </div>
          <div class="step">
            <span class="step-num">3</span>
            <span>Click <strong>Reload</strong> and try again</span>
          </div>
        </div>
        <div class="modal-actions">
          <button class="btn-primary" @click="reloadPage">
            <span class="material-icons">refresh</span>
            Reload Page
          </button>
          <button class="btn-link" @click="$emit('close')">Continue without {{ type === 'mic' ? 'microphone' : 'camera' }}</button>
        </div>
      </template>

      <!-- NORMAL STATE -->
      <template v-else>
        <h2 class="modal-title">
          {{ type === 'mic' ? 'Do you want people to hear you in the meeting?' : 'Do you want people to see you in the meeting?' }}
        </h2>
        <p class="modal-subtitle">You can still turn off your {{ type === 'mic' ? 'microphone' : 'camera' }} anytime in the meeting</p>
        <div class="modal-actions">
          <button class="btn-primary" @click="$emit('use-media')">
            <span class="material-icons">{{ type === 'mic' ? 'mic' : 'videocam' }}</span>
            Use {{ type === 'mic' ? 'microphone' : 'camera' }}
          </button>
          <button class="btn-link" @click="$emit('close')">Continue without {{ type === 'mic' ? 'microphone' : 'camera' }}</button>
        </div>
      </template>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    permanentlyDenied: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'mic', // 'mic' or 'camera'
    },
  },
  methods: {
    reloadPage() {
      window.location.reload()
    },
  },
}
</script>

<style scoped>
.mic-permission-dialog {
  border-radius: 16px !important;
  overflow: hidden;
}

.modal-content {
  text-align: center;
  padding: 10px 20px 30px;
}

.illustration-container {
  margin-bottom: 24px;
}

.illustration {
  width: 100%;
  max-width: 300px;
  height: auto;
}

.blocked-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.modal-title {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 12px;
  line-height: 1.3;
}

.modal-subtitle {
  font-size: 15px;
  color: #666;
  margin-bottom: 32px;
  line-height: 1.5;
}

.steps {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 28px;
  text-align: left;
}

.step {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  color: #333;
  background: #f5f7ff;
  padding: 10px 14px;
  border-radius: 8px;
}

.step-num {
  background: #0066da;
  color: white;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
  flex-shrink: 0;
}

.modal-actions {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
}

.btn-primary {
  background-color: #0066da;
  color: white;
  border: none;
  padding: 12px 32px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.2s;
  width: 100%;
  justify-content: center;
}

.btn-primary:hover {
  background-color: #0056b3;
}

.btn-link {
  background: none;
  border: none;
  color: #0066da;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
}

.btn-link:hover {
  text-decoration: underline;
}

::v-deep .el-dialog__header {
  padding-bottom: 0;
}
</style>
